export const downloadFile = (blob: Blob, fileName: string) => {
  if (!fileName) throw new Error("fileName is required");
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
